import { IGatsbyImageData } from 'gatsby-plugin-image';
import React from 'react';

// Context for switching between pug and organized in CM-guides
const ThumbnailContext = React.createContext<IGatsbyImageData | undefined>(
  undefined,
);

export default ThumbnailContext;
